<template>
    <div>
        <select-dropdown
            :autoTranslate="false"
            :disabled="disabled"
            enable-when-no-options
            :input-label="$t('multi-posting.contracts.groups.select.label')"
            keep-search-after-selection
            :loading="fetching"
            :options="groupOptions"
            :placeholder="$t('multi-posting.contracts.groups.select.placeholder')"
            remove-icon
            searchable
            :search-placeholder="$t('multi-posting.contracts.groups.select.item.label')"
            v-model="groupName"
            @removedSelection="contractTypes = []"
            @search="search($event)"
        />
    </div>
</template>

<script>
import Form from "../../etc/forms/Form";
import SelectDropdown from "../forms/SelectDropdown.vue";
import {mapState, mapActions} from "pinia";
import {useMultiPostingStore} from '../../state/modules/multiPosting';

export default {
    name: 'MultiPostingGroupSelection',
    components: { SelectDropdown },
    props: {
        form: Form,
        contract: Object,
        disabled: Boolean,
    },
    computed: {
        ...mapState(useMultiPostingStore, ['contractGroups']),
        groupOptions: function() {
            const groups = this.groups.map(group => ({
                value: group.id,
                label: group.name,
                suffix: group.id === -1 ? this.$t('multi-posting.contracts.groups.select.item.label') : null
            }));
            return groups.filter(group => group.label.toLowerCase() !== "default");
        }
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['fetchContractGroups']),
        search(value) {
            this.groups = this.groups.filter(group => group.id !== -1);
            if (value.length === 0) {
                return;
            }

            this.groups.unshift({
                id: -1,
                name: value
            });
        }
    },
    data() {
       return {
            groupName: null,
            fetching: true,
            groups: []
       };
    },
    mounted() {
        this.fetchContractGroups().then((result)  => {
            if (result) {
                this.groups = result.filter(group => !group.isUUID);
            }
            this.fetching = false;
        });
    },
    watch:
    {
        groupName: function (groupId) {
            const isNew = groupId === -1;
            const selectedOptions = this.groups.filter((group) => group.id === groupId);
            if (selectedOptions.length === 0) {
                return;
            }
            const selectedGroup = selectedOptions[0];
            const group = {
                id: selectedGroup.id,
                name: selectedGroup.name
            };
            this.$emit('group-selected', { isNew, group});
        }
    }
}
</script>
